<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'UserLayout',
})
</script>
<template>
  <div id="userLayout" class="user-layout-wrapper">
    <div class="user-layout-container">
      <div class="user-layout-left"></div>
      <div class="user-layout-right">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup name="UserLayout">
import { onMounted, onBeforeUnmount } from 'vue'

onMounted(() => {
  document.body.classList.add('userLayout')
})
onBeforeUnmount(() => {
  document.body.classList.remove('userLayout')
})
</script>

<style lang="less" scoped>
#userLayout.user-layout-wrapper {
  height: 100%;

  .user-layout-container {
    width: 100%;
    min-height: 100vh;
    display: flex;

    .user-layout-left {
      flex: 1224;
      background: url(../assets/login_back.png) no-repeat;
      background-size: cover;
      background-position: center;
      min-width: 0;
    }

    .user-layout-right {
      flex: 796;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 40px 32px;
      min-width: 260px;
      box-sizing: border-box;
    }
  }

  // 窄屏时图片作为整体背景，隐藏左侧面板，表单全宽居中
  @media (max-width: 856px) {
    .user-layout-container {
      background: url(../assets/login_back.png) no-repeat;
      background-size: cover;
      background-position: center;

      .user-layout-left {
        display: none;
      }

      .user-layout-right {
        flex: 1;
        background: transparent;
        min-width: 0;
        padding: 32px 16px;
      }
    }
  }
}
</style>
